export function Align(props) {
  const {
    children
  } = props;

  return <group>
  {children}
  </group>;
}

export default Align;
